import type { BadgeAssigneeBoolExp } from '@/gql/scalars';

export type BadgeDetailAssignmentCreatePathname = '/badge-assignee/create';

export type BadgeDetailAssignmentEditPathname =
  '/badge-assignee/[assigneeId]/edit';

export type BadgeDetailRoutePathnames = {
  assignmentCreatePathname: BadgeDetailAssignmentCreatePathname;
  assignmentEditPathname: BadgeDetailAssignmentEditPathname;
};

const routePathnames: BadgeDetailRoutePathnames = {
  assignmentCreatePathname: '/badge-assignee/create',
  assignmentEditPathname: '/badge-assignee/[assigneeId]/edit',
};

export function getBadgeDetailRoutePathnames(): BadgeDetailRoutePathnames {
  return routePathnames;
}

export function getBadgeDashboardAssignmentWhere({
  badgeId,
  eventId,
  teamId,
}: {
  badgeId: string;
  eventId?: string;
  teamId?: string;
}): BadgeAssigneeBoolExp {
  return {
    badge_id: { _eq: badgeId },
    ...(eventId ? { event_id: { _eq: eventId } } : {}),
    ...(teamId ? { team_id: { _eq: teamId } } : {}),
  };
}
